import { useShallow } from 'zustand/react/shallow';

import useClientState from '@/state/useClientState';

import { TooltipDetails } from '../types/TooltipStore';

const useTooltipStore = () => {
  const show = useClientState((state) => state.tooltip.show);
  const arrowPosition = useClientState((state) => state.tooltip.arrowPosition);
  const tooltipKey = useClientState((state) => state.tooltip.tooltipKey);
  const tooltipLeft = useClientState((state) => state.tooltip.mousePointer?.x ?? 0);
  const tooltipTop = useClientState((state) => state.tooltip.mousePointer?.y ?? 0);
  const data = useClientState((state) => state.tooltip.data);
  const locatieVoorEenheden = useClientState((state) => state.locatieVoorEenheden);
  const toelichting = useClientState((state) => (state.tooltip.data as TooltipDetails)?.toelichting);
  const tooltipTimeoutId = useClientState((state) => state.tooltip.tooltipTimeoutId);

  const veiligheidsConflicten = useClientState(
    useShallow((state) => {
      const { tooltipKey, data } = state.tooltip;
      if (
        tooltipKey === 'deeltraject' &&
        (data as TooltipDetails)?.inzetId &&
        state.perronLengteConflictInzet.has(String((data as TooltipDetails)?.inzetId))
      ) {
        const conflictIds = state.perronLengteConflictInzet.get(String((data as TooltipDetails)?.inzetId)) ?? [];
        return state.conflicten.filter((conflict) => conflictIds.includes(conflict.conflictId));
      }
      if (tooltipKey === 'leftLegend' || tooltipKey === 'leftLegendPerronLengteConflicten') {
        /** Double check that a given conflict matches the inzetten from the werklijn in the current horizon. */
        const werklijnInzetIds = (
          state.werklijnenMap.get(String((data as TooltipDetails)?.werklijnId))?.deelTrajecten ?? []
        ).map((inzet) => inzet.wleId);
        return state.conflicten.filter(
          (conflict) =>
            conflict.type === 'PERRONLENGTE' &&
            conflict.werklijnId === (data as TooltipDetails)?.werklijnId &&
            conflict.betrokkenWerklijnen?.some(
              (betrokken) => betrokken?.inzetId && werklijnInzetIds.includes(betrokken.inzetId),
            ),
        );
      }
      return [];
    }),
  );

  return {
    show,
    arrowPosition,
    tooltipKey,
    tooltipLeft,
    tooltipTop,
    data,
    locatieVoorEenheden,
    toelichting,
    tooltipTimeoutId,
    veiligheidsConflicten,
  };
};
export default useTooltipStore;
